@if (diameter !== undefined) {
  <mat-spinner [mode]="mode" [diameter]="diameter"></mat-spinner>
}
@if (diameter === undefined) {
  <mat-spinner
    [mode]="mode"
    [ngStyle]="{
      '--mat-progress-spinner-active-indicator-color': 'var(--green-800)',
    }"
  ></mat-spinner>
}
